import { Box } from '@mantine/core';
import { Text } from '../../components/ui/core';
import { IconHeart } from '@tabler/icons-react';

export default function MainFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      p="md"
      style={{
        textAlign: 'center',
        borderTop: '1px solid var(--mantine-color-gray-3)',
      }}
    >
      <Text size="sm" c="dimmed">
        Made with <IconHeart size={14} style={{ verticalAlign: 'middle', color: 'var(--mantine-color-red-6)' }} /> by Acts Christian Church © {currentYear}
      </Text>
    </Box>
  );
}
